import { useTranslate } from '@providers/TranslateProvider';

import { RedModal } from '@ui/components/RedModal/RedModal';

export type Props = {
  className?: string;
};

export function NetworkProblems({ className }: Props) {
  const { t } = useTranslate();
  return (
    <RedModal className={className} header={t('@features/game/ui/NetworkProblems/Header')}>
      {t('@features/game/ui/NetworkProblems/Text')}
    </RedModal>
  );
}
